import { UserDto, User, ConsoleRoles, DashboardRoles } from '@algoan/dashboard/model';
import { composeFullName } from '@algoan/dashboard/utils';

export const convertToUser = (userDto: UserDto): User => {
  const { licenses = [], projects = {} } = userDto.attributes ?? {};

  if (!userDto.firstName || !userDto.lastName || !userDto.email || !userDto.id) {
    throw new Error('User information is corrupt');
  }

  const projectNames = Object.values(projects);

  const user: User = {
    id: userDto.id,
    firstName: userDto.firstName,
    lastName: userDto.lastName,
    fullName: composeFullName(userDto.firstName, userDto.lastName),
    email: userDto.email,
    licenses,
    hasLicense: licenses.length > 0,
    language: userDto.attributes?.locale?.[0],
    firstConsoleLogin: userDto.attributes?.firstConsoleLogin,
    projects,
    projectNames,
    shouldBeNotifiedOnAnalysisCreated: userDto.attributes?.shouldBeNotifiedOnAnalysisCreated?.[0] === 'true',
    shouldBeNotifiedOnEveryAnalysisCreatedOfOrganization:
      userDto.attributes?.shouldBeNotifiedOnEveryAnalysisCreatedOfOrganization?.[0] === 'true',
    teamName: userDto.attributes?.team?.[0],
    team: undefined,
    sortableProjectNames: `${projectNames.length.toString().padStart(2, '0')}${projectNames.join(',')}`,
    enabled: userDto.enabled ?? false,
    createdTimestamp: userDto.createdTimestamp,
    passwordCreationTimestamp: userDto.passwordCreationTimestamp,
    emailVerified: userDto.emailVerified ?? false,
    platformRole:
      (userDto.roles?.find((role) => Object.values(ConsoleRoles).includes(role as ConsoleRoles)) as ConsoleRoles) ??
      undefined,
    dashboardRole:
      (userDto.roles?.find((role) =>
        Object.values(DashboardRoles).includes(role as DashboardRoles),
      ) as DashboardRoles) ?? DashboardRoles.NONE,
  };

  return user;
};
